export enum DriverStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
}
